export const SECURITY_FINANCIAL_REPORT_GROUP = [
  { label: 'financials_all', value: 'all' },
  { label: 'financials_q1_report', value: 'S1' },
  { label: 'financials_q2_report', value: 'S2' },
  { label: 'financials_q3_report', value: 'S3' },
  { label: 'financials_q4_report', value: 'S4' }
]

export const SECURITY_FINANCIAL_GROUP = [
  { label: 'market_revenue', value: 'revenue' },
  { label: 'market_net_profit', value: 'net_profit' },
  { label: 'market_eps', value: 'eps' },
  { label: 'market_pen', value: 'pen' },
  { label: 'financials_gross_margin', value: 'gross_margin' },
  { label: 'financials_basic_earnings_per_share', value: 'basic_earnings_per_share' },
  { label: 'financials_return_on_equity', value: 'return_on_equity' },
  { label: 'financials_debt_ratio', value: 'ebt_ratio' },
]